module.exports = __webpack_public_path__ + "static/media/BrixSans-Medium.45679d40.woff";